<template>
  <div class="layout-rank-node">
    <span v-popover:popover>为你推荐</span>
    <el-popover
      ref="popover"
      placement="top"
      width="300"
      trigger="hover">
      <div>
        <span>{{ text }}</span>
      </div>
    </el-popover>
  </div>
</template>

<script>
  export default {
    props: {
      data: {
        type: Object,
        default: () => ({})
      }
    },
    computed: {
      text() {
        const user = this.$store.state.user
        return `根据您的职能（${user.duty}），已为您匹配最适合的常用功能`
      }
    }
  }
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/layout/pages/home/common-menu-card/rank-node.vue